const baseUrl = "https://cdn4.sharechat.com";

const withBaseUrl = <T extends object>(baseUrl: string, imageUrls: T): T => {
  return Object.fromEntries(
    Object.entries(imageUrls).map(([key, value]) => [
      key,
      `${baseUrl}/${value}`,
    ])
  ) as T;
};

const imageUrls = {
  MOJ_LOGO: `2d182554_1699434629227_sc.png`,
  MOJ_LOGO_2X: `20110cdf_1699451882447_sc.png`,
  MOJ_ICON: `b30f596_1699458860990_sc.png`,
  CROSS_ICON_BLACK: `25a83ac5_1701424576025_sc.svg`,
};

const ImageUrls = withBaseUrl(baseUrl, imageUrls);

export default ImageUrls;
